import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // disable: true,
    themes: {
      light: {
        primary: '#394657',
        secondary: '#B9BEC4',
        header: '#101321',
        text: '#434550',
        button: '#E2E6EA',
        red: '#E86A7D',
        'red-light': '#FAE0E4',
        green: '#88DE6B',
        'green--light': '#E7F9E1',
        yellow: '#FFBF47',
        'yellow-light': '#FFF2DA',
        orange: '#E69E83',
        'orange-light': '#FCEEDE',
        blue: '#6C7BE6',
        'blue-light': '#E9EBFC',
        gray: '#B9BEC4',
        background: '#fcfcfc',
      },
      dark: {
        primary: '#323e50',
        secondary: '#B9BEC4',
        button: '#E2E6EA',
        red: '#E86A7D',
        'red-light': '#FAE0E4',
        green: '#88DE6B',
        'green--light': '#E7F9E1',
        yellow: '#FFBF47',
        'yellow-light': '#FFF2DA',
        orange: '#E69E83',
        'orange-light': '#FCEEDE',
        blue: '#6C7BE6',
        'blue-light': '#E9EBFC',
        gray: '#B9BEC4',
        background: '#fcfcfc',
      },
    },
  },
});
